export const PALABRAS_CON_ACENTRO: Record<string, string> = {
  transaccion: 'transacción',
  sera: 'será',
  dia: 'día',
  habil: 'hábil',
  aprobo: 'aprobó',
  comite: 'comité',
  credito: 'crédito',
  debito: 'débito',
};

export const TITULOS_POR_ATRIBUTO: Record<string, string> = {
  correo: 'Correo',
  telefono: 'Teléfono',
  persona: 'Nombre'
};
